export default function appendRupee(x) {
    const converted = new Intl.NumberFormat('en-IN', {
        maximumSignificantDigits: 21,
        style: 'currency',
        currency: 'INR'
    }).format(x);
    return converted;
}
